import * as yup from "yup";
export const quoteSchema = yup.object().shape({
  numeroDevis: yup.string().required("Numéro devis requis"),
  numeroCommande: yup.string().required("Numéro commande requis"),
  idClient: yup.string().required("id Client requis"),
  idUserClient: yup.string().required("id User Client requis"),
  engagementId: yup.string().required("Engagement requis"),
  issueDate: yup.date().required("Date d'émission requise"),
  startDate: yup.date().required(),
  paymentTerms: yup.string().required(),
  paymentDeadline: yup.string().required(),
  executionConditions: yup.string().required(),
  note: yup.string().required(),
  rib: yup.string().required(),
  items: yup.array().of(
    yup.object().shape({
      quantity: yup.number().required().min(1),
      unitPrice: yup.number().required().min(0),
      tva: yup.number().min(0),
      reduction: yup.number().min(0),
    })
  ),
  totalHT: yup.number().required(),
  tvaRate: yup.number().required(),
  totalTTC: yup.number().required(),
  discount: yup.number(),
});
